import { RecoilState, atom, selector } from "recoil";
import { OfoCodeResponse } from "../Component/Model/Dto/WSP/OfoCode";

export const OfoCodeAtom: RecoilState<OfoCodeResponse | null> = atom <OfoCodeResponse | null> ({
    key: 'OfoCodeAtom',
    default: null
});

export const ofoCodeSelector = selector<OfoCodeResponse | null>({
    key: 'ofoCodeSelector',
    get: ({ get }) => {
      const ofoCodeState = get(OfoCodeAtom);
      return ofoCodeState;
    },
  });